import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";
import { SetStateAction } from "react";
import * as EmailValidator from "email-validator";
import { CourtBookingApi } from "../apis/bookingapi";
import { Strings } from "../utils/strings";
import { NavigateFunction } from "react-router-dom";

export class LoginStore {
  rootStore: RootStore;
  modalData?: {
    visible: boolean;
    title: string;
    children: React.ReactNode | string;
    btnText?: string;
    btnVariant?: string;
    onClose: () => void;
    onAccept?: () => void;
    headerIcon?: React.ReactNode;
  };
  email?: string;
  isLoading: boolean = false;
  isValid: boolean = true;
  navigate?: NavigateFunction;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  setEmail = (email?: string) => {
    this.email = email;
  };

  handleEmailChange = (event: {
    target: { value: SetStateAction<string | undefined> };
  }) => {
    let value = event.target?.value?.toString();
    this.isValid = true;
    this.setEmail(value);
  };

  sendOTPCode = async () => {
    if (this.email && EmailValidator.validate(this.email)) {
      try {
        this.isLoading = true;
        await CourtBookingApi.otpCodeSend({
          email: `${this.email}`,
        });
        this.isValid = true;
        this.isLoading = false;
        this.navigate?.("/otp-verify");
      } catch (error: any) {
        this.isLoading = false;
        this.modalData = {
          visible: true,
          title: Strings.ERROR_SENDING_OTP,
          children:
            error.data?.message ??
            error.message ??
            "Some error occurred while sending OTP. Please try again.",
          btnText: Strings.OK,
          btnVariant: "outline-danger",
          onClose: () => (this.modalData = undefined),
        };
      }
    } else {
      this.isValid = false;
      this.modalData = {
        visible: true,
        title: Strings.INVALID,
        children: Strings.PLEASE_ENTER_VALID_NUMBER,
        btnText: Strings.OK,
        btnVariant: "outline-danger",
        onClose: () => (this.modalData = undefined),
      };
    }
  };

  handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior (form submission)
      this.sendOTPCode(); // Call sendOTPCode when Enter key is pressed
    }
  };
}
